import { createStore, compose, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'

import rootReducer, { RootState, rootPreloadedState, rootSaga } from './modules'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__?: typeof compose
  }
}

const createAppStore = (preloadedState: RootState = rootPreloadedState) => {
  const sagaMiddleware = createSagaMiddleware()

  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(sagaMiddleware),
      window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : (f: any) => f
    )
  )

  sagaMiddleware.run(rootSaga)

  return store
}

export type AppStore = ReturnType<typeof createAppStore>

export default createAppStore
